import { SUPPORTED_LANGS } from "@/i18n";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const SITE = "https://infinityfeedback.com";
const setMeta = (sel, attrs) => {
  let el = document.head.querySelector(sel);
  if (!el) { el = document.createElement(sel.startsWith("link") ? "link" : "meta"); document.head.appendChild(el); }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
};

export const useSeo = ({ title, description, path = "/", image = "/assets/pvc-matte.jpg", jsonLd, noindex = false }) => {
  const { i18n } = useTranslation();
  useEffect(() => {
    const url = SITE + path;
    document.title = title;
    document.documentElement.lang = i18n.language?.slice(0, 2) || "it";
    setMeta('meta[name="description"]', { name: "description", content: description });
    setMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex,nofollow" : "index,follow" });
    setMeta('link[rel="canonical"]', { rel: "canonical", href: url });
    SUPPORTED_LANGS.forEach((l) => setMeta(`link[hreflang="${l}"]`, { rel: "alternate", hreflang: l, href: `${url}${url.includes("?") ? "&" : "?"}lang=${l}` }));
    setMeta('link[hreflang="x-default"]', { rel: "alternate", hreflang: "x-default", href: url });
    [["og:title", title], ["og:description", description], ["og:url", url], ["og:type", "website"], ["og:image", SITE + image], ["og:site_name", "InfinityFeedback"]]
      .forEach(([p, c]) => setMeta(`meta[property="${p}"]`, { property: p, content: c }));
    [["twitter:card", "summary_large_image"], ["twitter:title", title], ["twitter:description", description], ["twitter:image", SITE + image]]
      .forEach(([n, c]) => setMeta(`meta[name="${n}"]`, { name: n, content: c }));
    let script = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!script) { script = document.createElement("script"); script.id = "seo-jsonld"; script.type = "application/ld+json"; document.head.appendChild(script); }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) script.remove();
  }, [title, description, path, image, noindex, i18n.language, JSON.stringify(jsonLd)]); // eslint-disable-line react-hooks/exhaustive-deps
};
